<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [link]="showProjectName && activity.Project ? ['/projects', activity.Project.Id] : null">
    <i scActivityIcon class="fa-sharp fa-solid fa-clipboard-check"></i>
    {{ texts.briefingCompleted[language] }}
</sc-activity-list-item>
